/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IndexRestoreMode } from '../models/IndexRestoreMode';

/**
* Advanced configuration for DynamoDB index restoration. Controls how Local Secondary Indexes (LSI) and Global Secondary Indexes (GSI) are handled during restore. By default, all indices are restored as they existed in the snapshot. 
*/
export class DynamoDBAdvancedIndexConfig {
  'localSecondaryIndexMode'?: IndexRestoreMode;
  'globalSecondaryIndexMode'?: IndexRestoreMode;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "localSecondaryIndexMode",
      "baseName": "localSecondaryIndexMode",
      "type": "IndexRestoreMode",
      "format": ""
    },
    {
      "name": "globalSecondaryIndexMode",
      "baseName": "globalSecondaryIndexMode",
      "type": "IndexRestoreMode",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DynamoDBAdvancedIndexConfig.attributeTypeMap;
  }

  public constructor() {
  }
}



